import type { PauseView } from "../render/pauseMenu";
import { BUTTON, type InputBits } from "../sim";
import type { ViewSettings } from "./settings";

const STEP = 10;

/** Пауза: «Продолжить», ползунки яркости вспышек и тряски. Управление — крестовина или стрелки, ✕ или Enter. */
const ITEMS = 4;

export class PauseController {
  isOpen = false;
  /** Открыт экран «Управление». */
  showControls = false;
  private selected = 0;
  private lastBits = 0;

  constructor(
    private readonly settings: ViewSettings,
    private readonly onChange: (settings: ViewSettings) => void,
  ) {}

  toggle(): void {
    if (this.showControls) {
      this.showControls = false;
      return;
    }
    this.isOpen = !this.isOpen;
    this.selected = 0;
  }

  handle(bits: InputBits, confirm: boolean): void {
    const pressed = bits & ~this.lastBits;
    this.lastBits = bits;
    if (this.showControls) {
      if (confirm) this.showControls = false;
      return;
    }
    if (pressed & BUTTON.up) this.selected = (this.selected + ITEMS - 1) % ITEMS;
    if (pressed & BUTTON.down) this.selected = (this.selected + 1) % ITEMS;
    if (confirm && this.selected === 1) {
      this.showControls = true;
      return;
    }
    const delta = (pressed & BUTTON.right ? STEP : 0) - (pressed & BUTTON.left ? STEP : 0);
    if (delta !== 0 && this.selected > 1) {
      const key: keyof ViewSettings = this.selected === 2 ? "flash" : "shake";
      this.settings[key] = Math.min(100, Math.max(0, this.settings[key] + delta));
      this.onChange(this.settings);
    }
    if (confirm && this.selected === 0) this.isOpen = false;
  }

  view(): PauseView {
    return {
      items: [
        { label: "Продолжить" },
        { label: "Управление: кнопки и приёмы" },
        { label: "Яркость вспышек", value: this.settings.flash },
        { label: "Тряска экрана", value: this.settings.shake },
      ],
      selected: this.selected,
    };
  }
}
